module.exports = __webpack_public_path__ + "img/teaser_002.e43a8f0e.png";